export const Navigation = (props) => {
  return (
    <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
      
      <div className='container'>
        <div className='navbar-header'>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            data-target='#bs-example-navbar-collapse-1'
          >
            {' '}
            <span className='sr-only'>Toggle navigation</span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
          </button>
          
          <div className='colbar'>
            <div className='navbar-header'>
              <a className='navbar-brand page-scroll' href='#page-top'>
                <img alt={'logo'} src={'/Tofanitty_banner.png'} width='160rem' height='50rem' />
              </a>
            </div>
            {' '}
          </div>
        </div>

        <div
          className='collapse navbar-collapse navbar-items'
          id='bs-example-navbar-collapse-1'
        >
          <ul className='nav navbar-nav navbar-right'>
            <li>
              <a href='#features' className='page-scroll'>
                Download
              </a>
            </li>
            <li>
              <a href='#about' className='page-scroll'>
                About
              </a>
            </li>
            <li>
              <a href='#portfolio' className='page-scroll'>
                Photos
              </a>
            </li>
            {/* <li>
              <a href='#testimonials' className='page-scroll'>
                Reviews
              </a>
            </li> */}
            <li>
              <a href='#team' className='page-scroll'>
                Team
              </a>
            </li>
            {/*<li>
              <a href='#services' className='page-scroll'>
                Services
              </a>
            </li>*/}
            <li>
              <a href='#contact' className='page-scroll'>
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}
